import React from 'react';
import { formatCurrency } from '../../utils/currencyFormatter';
import { PackageIcon, FileTextIcon, TicketIcon, UsersIcon, CalendarIcon, AlertTriangleIcon, ArrowRightIcon } from 'lucide-react';
export function LicenseDashboard({
  locale,
  onNavigate
}) {
  // Mock data for the dashboard
  const summaryData = {
    totalModules: 8,
    activeModules: 6,
    volumeUsage: {
      current: 75420,
      limit: 100000,
      metric: 'Documents',
      percentage: 75
    },
    occasionalPasses: {
      remaining: 42,
      used: 18,
      total: 60
    },
    activeSessions: 14,
    renewalDue: 45
  };
  const alerts = [{
    id: 'alert-1',
    type: 'warning',
    message: 'Vendor Management module license expires in 7 days',
    action: 'Renew Now',
    module: {
      id: 'module-2',
      name: 'Vendor Management'
    }
  }, {
    id: 'alert-2',
    type: 'danger',
    message: 'Document volume usage at 75% of limit',
    action: 'Upgrade Plan',
    plan: {
      id: 'plan-1',
      name: 'Enterprise Document Plan'
    }
  }];
  return <div className="space-y-6" data-id="element-17695">
      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-5" data-id="element-17696">
        {/* Licensed Modules */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17697">
          <div className="px-4 py-5 sm:p-6" data-id="element-17698">
            <div className="flex items-center" data-id="element-17699">
              <div className="flex-shrink-0 bg-indigo-100 rounded-md p-3" data-id="element-17700">
                <PackageIcon className="h-6 w-6 text-indigo-600" data-id="element-17701" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17702">
                <dl data-id="element-17703">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17704">
                    Licensed Modules
                  </dt>
                  <dd data-id="element-17705">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17706">
                      {summaryData.activeModules} / {summaryData.totalModules}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17707">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17708">
                View all modules
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17709" />
              </button>
            </div>
          </div>
        </div>
        {/* Volume Usage */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17710">
          <div className="px-4 py-5 sm:p-6" data-id="element-17711">
            <div className="flex items-center" data-id="element-17712">
              <div className="flex-shrink-0 bg-blue-100 rounded-md p-3" data-id="element-17713">
                <FileTextIcon className="h-6 w-6 text-blue-600" data-id="element-17714" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17715">
                <dl data-id="element-17716">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17717">
                    Volume Usage ({summaryData.volumeUsage.metric})
                  </dt>
                  <dd data-id="element-17718">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17719">
                      {summaryData.volumeUsage.current.toLocaleString()} /{' '}
                      {summaryData.volumeUsage.limit.toLocaleString()}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17720">
              <div className="relative" data-id="element-17721">
                <div className="overflow-hidden h-2 text-xs flex rounded bg-blue-100" data-id="element-17722">
                  <div style={{
                  width: `${summaryData.volumeUsage.percentage}%`
                }} className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-blue-500" data-id="element-17723"></div>
                </div>
                <div className="text-xs text-gray-500 mt-1 text-right" data-id="element-17724">
                  {summaryData.volumeUsage.percentage}% used
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Occasional Passes */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17725">
          <div className="px-4 py-5 sm:p-6" data-id="element-17726">
            <div className="flex items-center" data-id="element-17727">
              <div className="flex-shrink-0 bg-green-100 rounded-md p-3" data-id="element-17728">
                <TicketIcon className="h-6 w-6 text-green-600" data-id="element-17729" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17730">
                <dl data-id="element-17731">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17732">
                    Occasional Passes
                  </dt>
                  <dd data-id="element-17733">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17734">
                      {summaryData.occasionalPasses.remaining} remaining
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17735">
              <button type="button" onClick={() => onNavigate('passes')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17736">
                Manage passes
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17737" />
              </button>
            </div>
          </div>
        </div>
        {/* Active Sessions */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17738">
          <div className="px-4 py-5 sm:p-6" data-id="element-17739">
            <div className="flex items-center" data-id="element-17740">
              <div className="flex-shrink-0 bg-purple-100 rounded-md p-3" data-id="element-17741">
                <UsersIcon className="h-6 w-6 text-purple-600" data-id="element-17742" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17743">
                <dl data-id="element-17744">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17745">
                    Active Sessions
                  </dt>
                  <dd data-id="element-17746">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17747">
                      {summaryData.activeSessions} today
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17748">
              <button type="button" onClick={() => onNavigate('usage')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17749">
                View usage details
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17750" />
              </button>
            </div>
          </div>
        </div>
        {/* Renewal Due */}
        <div className="bg-white overflow-hidden shadow rounded-lg" data-id="element-17751">
          <div className="px-4 py-5 sm:p-6" data-id="element-17752">
            <div className="flex items-center" data-id="element-17753">
              <div className="flex-shrink-0 bg-yellow-100 rounded-md p-3" data-id="element-17754">
                <CalendarIcon className="h-6 w-6 text-yellow-600" data-id="element-17755" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-17756">
                <dl data-id="element-17757">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-17758">
                    Next Renewal
                  </dt>
                  <dd data-id="element-17759">
                    <div className="text-lg font-medium text-gray-900" data-id="element-17760">
                      {summaryData.renewalDue} days
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
            <div className="mt-4" data-id="element-17761">
              <button type="button" onClick={() => onNavigate('modules')} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-17762">
                View renewals
                <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-17763" />
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Alerts */}
      <div className="bg-white shadow sm:rounded-lg" data-id="element-17764">
        <div className="px-4 py-5 sm:px-6" data-id="element-17765">
          <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-17766">
            License Alerts
          </h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-17767">
            Important notifications about your licenses and usage
          </p>
        </div>
        <div className="border-t border-gray-200" data-id="element-17768">
          <div className="divide-y divide-gray-200" data-id="element-17769">
            {alerts.map(alert => <div key={alert.id} className="px-4 py-4 sm:px-6" data-id="element-17770">
                <div className="flex items-start" data-id="element-17771">
                  <div className={`flex-shrink-0 ${alert.type === 'warning' ? 'text-yellow-400' : 'text-red-400'}`} data-id="element-17772">
                    <AlertTriangleIcon className="h-5 w-5" data-id="element-17773" />
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5" data-id="element-17774">
                    <p className="text-sm font-medium text-gray-900" data-id="element-17775">
                      {alert.message}
                    </p>
                    <div className="mt-3 flex" data-id="element-17776">
                      <button type="button" className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" onClick={() => {
                    if (alert.module) {
                      onNavigate('module-detail', alert.module);
                    } else if (alert.plan) {
                      onNavigate('plan-detail', alert.plan);
                    }
                  }} data-id="element-17777">
                        {alert.action}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
            {alerts.length === 0 && <div className="px-4 py-5 sm:px-6 text-center text-sm text-gray-500" data-id="element-17778">
                No alerts at this time. All licenses are in good standing.
              </div>}
          </div>
        </div>
      </div>
    </div>;
}